import type {Workspace} from "@vesta/vos-types/modules/platformLevel/workspaces/domain/Workspace";
import type {WorkspaceMobileNavigationConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceMobileBottomCreateItem";
import {AMARON_DEFAULT_MOBILE_BOTTOM_CREATE_SHEET} from "~/domainModels/workspaceSpecific/amaronCreateFormConfig";
import {DULUX_DEFAULT_MOBILE_BOTTOM_CREATE_SHEET} from "~/domainModels/workspaceSpecific/duluxCreateFormConfig";
import {EMOTORAD_DEFAULT_MOBILE_BOTTOM_CREATE_SHEET} from "~/domainModels/workspaceSpecific/emotoradCreateFormConfig";

function isWorkspaceNameMatch(workspace: Pick<Workspace, "displayName">, name: string): boolean {
    return workspace.displayName.toLowerCase().includes(name);
}

export function resolveWorkspaceListCreateItemsConfiguration({
    workspace,
    configuration,
}: {
    workspace: Pick<Workspace, "displayName">;
    configuration: WorkspaceMobileNavigationConfiguration | null;
}): WorkspaceMobileNavigationConfiguration | null {
    if (configuration === null || configuration.mobileBottomCreateSheet !== undefined) {
        return configuration;
    }

    if (isWorkspaceNameMatch(workspace, "amaron") === true) {
        return {
            ...configuration,
            mobileBottomCreateSheet: [...AMARON_DEFAULT_MOBILE_BOTTOM_CREATE_SHEET],
        };
    }

    if (isWorkspaceNameMatch(workspace, "dulux") === true) {
        return {
            ...configuration,
            mobileBottomCreateSheet: [...DULUX_DEFAULT_MOBILE_BOTTOM_CREATE_SHEET],
        };
    }

    if (isWorkspaceNameMatch(workspace, "emotorad") === true) {
        return {
            ...configuration,
            mobileBottomCreateSheet: [...EMOTORAD_DEFAULT_MOBILE_BOTTOM_CREATE_SHEET],
        };
    }

    return configuration;
}
